const UserRoleEnum = Object.freeze({
    SUPERADMIN: 'super-admin',
    ADMIN: 'admin',
    PARTNER: 'partner',
    TOURNAMENTMANAGER: 'tournament-manager',
    STAFF: 'staff',
    STANDARDUSER: 'standard-user',
    TICKETINGADMIN: 'ticketing-manager'
});

export default UserRoleEnum;
